import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { DATE_RANGE_OPTION } from '@shared/features/views/components/entities-filters/type';
import { FILTER_COLOR } from './filter-colors';

export const birthDateFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'birth_date_before',
    after: 'birth_date_after',
  }),
  color: FILTER_COLOR.green,
  includedDateRanges: [
    DATE_RANGE_OPTION.AFTER_DATE,
    DATE_RANGE_OPTION.BEFORE_DATE,
    DATE_RANGE_OPTION.EXACT_DATE,
    DATE_RANGE_OPTION.DATE_RANGE,
  ],
});
